var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0616 3.91918V1L8.73513 5.32647L13.0616 9.55785V5.83994C15.7621 6.29636 17.816 8.6355 17.816 11.4596C17.816 14.2837 15.7621 16.6228 13.0616 17.0792V19C16.8175 18.5341 19.7177 15.3391 19.7177 11.4596C19.7177 7.58003 16.8175 4.3851 13.0616 3.91918ZM7.45145 17.4691C8.55446 18.3249 9.83814 18.8384 11.1599 19V17.0697C10.3326 16.9271 9.53386 16.6038 8.82071 16.0903L7.45145 17.4691ZM6.49107 12.4105H4.57031C4.73196 13.7322 5.25494 15.0063 6.11072 16.1094L7.45145 14.7591C6.957 14.046 6.6242 13.2472 6.49107 12.4105ZM7.46096 8.16006L6.12023 6.80983C5.26445 7.91284 4.73196 9.18701 4.57031 10.5087H6.49107C6.6242 9.68146 6.957 8.87322 7.46096 8.16006Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.f7cdc6a0052586c982da1431d628a274.svg";
export { ForwardRef as ReactComponent };